import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { VAPOR_INTRUSION_ZONE } from '../constants';

export default class VaporIntrusionSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: VAPOR_INTRUSION_ZONE.FIELD_NAME.REPORT_IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: VAPOR_INTRUSION_ZONE.FIELD_NAME.REPORT_NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: VAPOR_INTRUSION_ZONE.FIELD_NAME.REPORT_NUMBER,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: VAPOR_INTRUSION_ZONE.FIELD_NAME.REPORT_DATE,
        enteredValue: '',
        dataType: FieldDataType.date,
        validation: null,
      }),
    ]);
  }
}
